import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import UserImport from './UserImport';
import ImportResultsModal from './ImportResultsModal';

/**
 * UserImportDialog component that manages both the import modal and results modal.
 * This composite component encapsulates all the modal state management and transitions.
 * @param {boolean} show - Controls the visibility of the import dialog
 * @param {function} onHide - Callback when the dialog is closed
 * @param {function} onImportComplete - Callback when import completes successfully
 */
const UserImportDialog = ({ show, onHide, onImportComplete }) => {
  const [showResults, setShowResults] = useState(false);
  const [importResults, setImportResults] = useState(null);

  /**
   * Handles when import completes - transitions to results modal.
   * Call the parent callback for any side effects (like refreshing user list)
   */
  const handleImportComplete = (results) => {
    setImportResults(results);
    setShowResults(true);

    if (onImportComplete) {
      onImportComplete(results);
    }
  };

  /**
   * Handles closing the result modal - returns to the main dialog or closes entirely.
   */
  const handleResultsClose = () => {
    setShowResults(false);
    setImportResults(null);
    onHide();
  };

  /**
   * Handles "Import Another File" - returns to the main import dialog.
   * Keep the main dialog open for another import
   */
  const handleImportAnother = () => {
    setShowResults(false);
    setImportResults(null);
  };

  /**
   * Handles closing the main import dialog.
   * Reset any pending results.
   */
  const handleMainDialogClose = () => {
    setShowResults(false);
    setImportResults(null);
    onHide();
  };

  return (
    <>
      <Modal
        show={show && !showResults}
        onHide={handleMainDialogClose}
        size="lg"
        centered
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
      >
        <Modal.Body 
          className="p-0" 
          style={{ 
            backgroundColor: 'transparent',
            padding: '0',
            width: '100%'
          }}
        >
          <UserImport
            onImportComplete={handleImportComplete}
            onClose={handleMainDialogClose}
          />
        </Modal.Body>
      </Modal>

      <ImportResultsModal
        show={showResults}
        onHide={handleResultsClose}
        importResults={importResults}
        onImportAnother={handleImportAnother}
      />
    </>
  );
};

export default UserImportDialog;